import './js-sdk/src';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';

import ErrorBoundary from './components/ErrorBoundaries/GeneralError';
import PatientFacing from './components/PatientFacing';
import enLocale from './locales/en';
import store from './store';

import './PatientMessengerBase.css';

export const PatientMessenger = () => (
  <Provider store={store}>
    <IntlProvider messages={enLocale} locale="en">
      <ErrorBoundary>
        <PatientFacing />
      </ErrorBoundary>
    </IntlProvider>
  </Provider>
);

export default PatientMessenger;
